export default "__VITE_ASSET__lURQdYrk__"